<template>
    <div class="cal__bloc_header cal__font_bree" 
        v-bind:class="[{ 'cal__bloc--active': this.$store.state.idCategoryActive === idCategory}, idCategory === 3 ? 'cal__bloc_header3' : '']"
        v-on:mouseenter="updateCategory"
        v-on:click="updateCategory"
    >
        <span class="cal__bloc_number">{{ idCategory }}</span>
        <span class="cal__bloc_title">{{ name }}</span>
    </div>
</template>

<script>
export default {
  name: 'AppBodyHeaderField',
  props: [ 'idCategory', 'name' ],
  methods: {
    updateCategory(){
      this.$store.commit('UPDATE_CATEGORY_ACTIVE', { categoryid: this.idCategory })
    }
  }
}
</script>

